module.exports = __webpack_public_path__ + "img/slide15.95b52629.png";